import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import HomeFilter from './HomeFilter';
import FilterNav from './FilterNav';

const apiUrl = process.env.REACT_APP_API_URL;
let debounceTimeout: NodeJS.Timeout;
const homeUrl = process.env.REACT_APP_HOME_URL;

const TrendingCoins = ({ activeTab, currentPage, setCurrentPage, totalPages, setTotalPages, loading, setLoading }) => {
  const navigate = useNavigate();
  const [coins, setCoins] = useState([]);
  const [error, setError] = useState(null);

  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const fetchTrendingCoins = async () => {
      const query = new URLSearchParams({ page_number: currentPage }).toString();
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/coins/trending?${query}`);
        const data = await response.json();
        setCoins(data);
        setError(null);
      } catch (error) {
        console.error('Error fetching trending coins:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingCoins();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    console.log(direction);
    setCurrentPage((prevPage) => {
      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1); // Minimum page is 1
      } else if (direction === 'next') {
        return Math.min(prevPage + 1, totalPages); // Maximum page is totalPages
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
      return prevPage;
    });
  };

  if (error) return <div className="text-center py-10 text-red-500">{error}</div>;

  return (
    <>
      {path === '/trending-coins' && (
        <div className="toppagetitle">
          <div className="container">
            <div className="pagetitle">
              <h1>Trending Coins</h1>
            </div>
          </div>
        </div>
      )}
      <HomeFilter coins={coins} activeTab={activeTab} />
      <div className="btn_mainsec">
        <button
          className="btn_style"
          onClick={() => handlePageChange('prev')}
          disabled={currentPage === 1}
        >
          Previous
        </button>

        <button
          className="btn_style"
          onClick={() => handlePageChange('next')}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </>
  );
};

export default TrendingCoins;